import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FiEye,
  FiEyeOff,
  FiUploadCloud,
} from "react-icons/fi";
import { toast } from "react-toastify";
import { registerSchool } from "../services/authService";
import "./SignupLayer.css";

export const SignupLayer = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    address: "",
    reference_by: "",
    logo: null,
  });

  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (!form.logo) {
      setPreview(null);
      return;
    }

    const url = URL.createObjectURL(form.logo);
    setPreview(url);

    return () => URL.revokeObjectURL(url);
  }, [form.logo]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const validate = () => {
    let err = {};

    if (!form.name) {
      err.name = "School name is required";
    }

    if (!form.email) {
      err.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      err.email = "Invalid email format";
    }

    if (!form.phone) {
      err.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.phone)) {
      err.phone = "Enter a valid 10-digit Indian number";
    }

    if (!form.password || form.password.length < 6) {
      err.password = "Password must be 6+ chars";
    }

    if (!form.logo) {
      err.logo = "Please upload a logo";
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    setLoading(true);

    try {
      console.log("FORM DATA =>", form);

      const res = await registerSchool(form);

      console.log("REGISTER RESPONSE =>", res);

      if (res.status === true || res.status === "success") {
        toast.success(res.message || "Registration Successful!");

        setTimeout(() => {
          navigate("/sign-in");
        }, 2000);

      } else {
        toast.error(res.message || "Registration failed");
      }

    } catch (err) {
      console.log("FULL ERROR =>", err);
      console.log("ERROR RESPONSE =>", err?.response);

      toast.error(
        err?.response?.data?.message ||
        err.message ||
        "Network error. Please try again."
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">

        <div className="signup-left">
          <h5>Create School Account</h5>
          <p>Join the future of digital school management.</p>
        </div>

        <div className="signup-right">
          <h3>Register School</h3>

          <p className="signup-subtitle">
            Provide your institutional details
          </p>

          <form onSubmit={handleSubmit}>

            {/* LOGO */}
            <div className="form-group full-width">
              <label>School Logo</label>

              <div className="logo-upload-container">

                <div className="logo-preview">
                  {preview ? (
                    <img src={preview} alt="Preview" />
                  ) : (
                    <FiUploadCloud size={24} />
                  )}
                </div>

                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleChange}
                  className="input-style"
                />
              </div>

              {errors.logo && (
                <span className="error-text">
                  {errors.logo}
                </span>
              )}
            </div>

            <div className="form-grid">

              {/* SCHOOL NAME */}
              <div className="form-group">
                <label>School Name</label>

                <input
                  name="name"
                  placeholder="School Name"
                  value={form.name}
                  onChange={handleChange}
                  className="input-style"
                />

                {errors.name && (
                  <span className="error-text">
                    {errors.name}
                  </span>
                )}
              </div>

              {/* EMAIL */}
              <div className="form-group">
                <label>Email</label>

                <input
                  name="email"
                  type="email"
                  placeholder="admin@school.com"
                  value={form.email}
                  onChange={handleChange}
                  className="input-style"
                />

                {errors.email && (
                  <span className="error-text">
                    {errors.email}
                  </span>
                )}
              </div>

              {/* PHONE */}
              <div className="form-group">
                <label>Mobile Number (India)</label>

                <input
                  name="phone"
                  maxLength={10}
                  placeholder="10 Digit Number"
                  value={form.phone}
                  onChange={handleChange}
                  className="input-style"
                />

                {errors.phone && (
                  <span className="error-text">
                    {errors.phone}
                  </span>
                )}
              </div>

              {/* PASSWORD */}
              <div className="form-group">
                <label>Password</label>

                <div className="password-wrapper">

                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="••••••••"
                    value={form.password}
                    onChange={handleChange}
                    className="input-style"
                  />

                  <span
                    className="eye-icon"
                    onClick={() =>
                      setShowPassword(!showPassword)
                    }
                  >
                    {showPassword ? (
                      <FiEyeOff size={18} />
                    ) : (
                      <FiEye size={18} />
                    )}
                  </span>
                </div>

                {errors.password && (
                  <span className="error-text">
                    {errors.password}
                  </span>
                )}
              </div>

              {/* REFERENCE BY */}
              <div className="form-group">
                <label>Reference By</label>

                <input
                  type="text"
                  name="reference_by"
                  placeholder="Reference By"
                  value={form.reference_by}
                  onChange={handleChange}
                  className="input-style"
                />
              </div>

            </div>

            {/* ADDRESS */}
            <div className="form-group full-width">
              <label>Address</label>

              <textarea
                name="address"
                rows="2"
                placeholder="Full Address"
                value={form.address}
                onChange={handleChange}
                className="input-style"
              />
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              className="signup-btn text-center"
              disabled={loading}
            >
              {loading ? "Processing..." : "Create Account"}
            </button>

          </form>

          <div className="form-footer">
            Already have an account?{" "}

            <Link
              to="/sign-in"
              className="signin-link"
            >
              Sign In
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};